import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Drawer, Typography } from 'antd';
import styled from 'styled-components';

import { PidCategoryList } from '@/entities/personalIdentifiers/components/PidCategoryList';
import { Container } from '@/shared/components/layout';
import { COLORS } from '@/shared/constants/colors';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm';

import { useModalsStore } from '../../modals.store';
import { SelectPidTypeModalProps } from '../../types';

export const SelectPidTypeModal: FC<SelectPidTypeModalProps> = ({ onSelect }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectPidType' });
  const modals = useModalsStore();

  const handleSelect = (category: PersonalIdentifierType) => {
    modals.closeModal();
    onSelect(category);
  };

  return (
    <StyledDrawer
      height={'80vh'}
      placement="bottom"
      closable={false}
      onClose={modals.closeModal}
      open={true}
    >
      <Container paddingX={24} paddingY={16}>
        <DrawerTitle>{t('title')}</DrawerTitle>
      </Container>
      <Divider style={{ margin: 0 }} />
      <PidCategoryList onSelect={handleSelect} />
      {/* {typeList.map((iType) => (
        <Fragment key={iType}>
          <Divider style={{ margin: 0 }} />
          <Container paddingX={24} paddingY={16} style={{ cursor: 'pointer' }}>
            <Typography.Title
              level={4}
              onClick={}
              // style={!form ? { opacity: 0.7 } : {}}
              // data-testid={documentCategory}
            >
              {td(DocumentCategoryToText[iType])}
            </Typography.Title>
          </Container>
        </Fragment>
      ))} */}
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  &&& {
    .ant-drawer-body {
      padding: 0;
    }
  }
`;

const DrawerTitle = styled(Typography.Text)`
  &&& {
    font-size: 16px;
    color: ${COLORS.colorTextTertiary};
  }
`;
